import {
  PERFORMANCE_FILTER_DEFAULT_MAX_STAR,
  PERFORMANCE_FILTER_DEFAULT_MIN_STAR,
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT,
  PERFORMANCE_STATUS_LABELS,
  storesPerformanceExportHeaders,
} from "../../../constants/shared/performanceFilter.constants";

export const groupPerformanceConstants = {
  ALL_GROUP_RESPONSE_DATA: "ALL_GROUP_RESPONSE_DATA",
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA: "CUSTOMER_RESPONSES_EXPORT_ALL_DATA",
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING:
    "STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING",
};

export const groupPerformanceExportHeaders = storesPerformanceExportHeaders;

export const columnHeadersConstants = {
  SENTIMENT_CHANGE: "SENTIMENT CHANGE",
  TRANSACTION_CHANGE: "TRANSACTION CHANGE",
};

export const groupPerformanceStoresName = "Group Performance (Stores)";

export const GROUP_PERFORMANCE_SELECT_MAX_MENU_HEIGHT =
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT;
export const GROUP_PERFORMANCE_DEFAULT_MAX_STAR =
  PERFORMANCE_FILTER_DEFAULT_MAX_STAR;
export const GROUP_PERFORMANCE_DEFAULT_MIN_STAR =
  PERFORMANCE_FILTER_DEFAULT_MIN_STAR;

export const GROUP_PERFORMANCE_LABELS = {
  TOTAL_STORES: PERFORMANCE_STATUS_LABELS.TOTAL_STORES,
  TOTAL_RESPONSES: PERFORMANCE_STATUS_LABELS.TOTAL_RESPONSES,
  EXPORT: "Export",
  DATA_TABLE: "Data Table",
  DETAILED_CUSTOMER_SURVEY_DATA: "Detailed Customer Survey Data",
  STORE_NAME: "STORE NAME",
  TOTAL_RESPONSES_COLUMN: "TOTAL RESPONSES",
  AVERAGE_TRANSACTION_RATING: "AVERAGE TRANSACTION RATING",
  AVERAGE_SENTIMENT_RATING: "AVERAGE SENTIMENT RATING",
  PREVIOUS: "PREVIOUS",
  DAY: "DAY",
  DAYS: "DAYS",
};
